import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { AuthImgPipe } from './auth-img/auth-img.pipe';
import { FancyCurrencyPipe } from './fancy-currency/fancy-currency.pipe';
import { SafeHtmlPipe } from './safeHtml/safe-html.pipe';
import { HideEmailPipe } from './hide-email/hide-email.pipe';
import { SplitStringsPipe } from './text-separator/text-separator.pipe';
import { FilterByNamePipe } from './filterByName/filter-by-name.pipe';
import { ToNumberPipe } from './toNumber/to-number.pipe';

@NgModule({
   imports: [
      CommonModule,
      HttpClientModule,
   ],
   declarations: [
      AuthImgPipe,
      FancyCurrencyPipe,
      SafeHtmlPipe,
      HideEmailPipe,
      FilterByNamePipe,
      ToNumberPipe
   ],
   exports: [
      AuthImgPipe,
      FancyCurrencyPipe,
      SafeHtmlPipe,
      HideEmailPipe,
      FilterByNamePipe,
      ToNumberPipe
   ],
})
export class PipesModule { }
